export const comics = [
  {
    id: 1,
    slug: "quan-zhi-du-zhe-shi-jiao",
    title: "全知读者视角",
    altTitle: "Omniscient Reader's Viewpoint",
    author: "sing N song",
    artist: "Sleepy-C",
    status: "连载中",
    category: "奇幻冒险",
    tags: ["奇幻", "冒险", "系统", "穿越"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20young%20man%20with%20dark%20hair%20holding%20a%20book%20with%20glowing%20blue%20effects%2C%20fantasy%20adventure%20theme%2C%20dramatic%20lighting%20with%20constellation%20background%2C%20clean%20line%20art%2C%20vibrant%20colors%2C%20manga%20style%20illustration&width=800&height=1120&seq=comic-omniscient-reader&orientation=portrait",
    description: "平凡上班族金独子，在通勤地铁上阅读一部无人问津的网络小说《在灭亡的世界中存活的三种方法》。当小说完结的那一刻，世界突然变成了小说中的场景，而他成为了唯一知道这个世界结局的人。",
    rating: 9.8,
    views: 1580000,
    chapters: 234,
    updateDate: "2026-07-02",
    featured: true,
  },
  {
    id: 2,
    slug: "du-zun",
    title: "独尊",
    altTitle: "The Only One",
    author: "Redice Studio",
    artist: "Redice Studio",
    status: "连载中",
    category: "武侠格斗",
    tags: ["武侠", "格斗", "重生", "强者"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20powerful%20warrior%20with%20martial%20arts%20stance%2C%20dark%20flowing%20hair%2C%20ancient%20Chinese%20martial%20arts%20clothing%2C%20dramatic%20chi%20energy%20effects%2C%20mountainous%20background%2C%20clean%20inking%2C%20vibrant%20color%20palette%2C%20dynamic%20action%20pose&width=800&height=1120&seq=comic-solo-leveling-style&orientation=portrait",
    description: "武林至尊独孤一剑，重生回到少年时代。这一次，他不仅要重登巅峰，更要将所有曾经背叛他的人踩在脚下。带着前世的记忆与经验，他踏上了一条碾压一切的霸道之路。",
    rating: 9.6,
    views: 2340000,
    chapters: 189,
    updateDate: "2026-07-03",
    featured: true,
  },
  {
    id: 3,
    slug: "zai-sheng-zhi-du-sha",
    title: "再生之毒杀",
    altTitle: "Rebirth Poison",
    author: "Studio JBB",
    artist: "Kim Hyun-soo",
    status: "已完结",
    category: "悬疑惊悚",
    tags: ["悬疑", "惊悚", "重生", "复仇"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20dark%20mystery%20style%2C%20a%20determined%20woman%20in%20black%20dress%20with%20sharp%20eyes%2C%20dark%20purple%20poison%20mist%20surrounding%2C%20mysterious%20atmosphere%2C%20clean%20line%20art%2C%20dramatic%20shadows%2C%20thriller%20mood&width=800&height=1120&seq=comic-rebirth-poison&orientation=portrait",
    description: "被丈夫和闺蜜联手毒杀后，她重生回到了五年前。这一次，她不再是那个天真的女人。带着前世的记忆，她要用最完美的方式，让曾经伤害过她的人付出代价。毒蛇般的复仇，悄然展开。",
    rating: 9.5,
    views: 1890000,
    chapters: 156,
    updateDate: "2026-06-15",
    featured: false,
  },
  {
    id: 4,
    slug: "wo-de-zhai-jun-lao-gong",
    title: "我的债君老公",
    altTitle: "My Debt Husband",
    author: "Yoo Seo-jin",
    artist: "Park Min-ji",
    status: "连载中",
    category: "恋爱浪漫",
    tags: ["恋爱", "浪漫", "契约", "豪门"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20style%2C%20elegant%20woman%20in%20white%20blouse%20facing%20handsome%20man%20in%20suit%2C%20soft%20pink%20rose%20petals%20floating%2C%20romantic%20cityscape%20background%2C%20delicate%20line%20art%2C%20warm%20color%20tones%2C%20beautiful%20illustration&width=800&height=1120&seq=comic-debt-husband&orientation=portrait",
    description: "为了偿还父亲的债务，她嫁给了那个冷酷无情的高利贷老板。原以为是地狱的开始，却发现这个表面冷漠的男人，内心藏着不为人知的温柔。一段契约婚姻，两颗逐渐靠近的心。",
    rating: 9.3,
    views: 1250000,
    chapters: 98,
    updateDate: "2026-07-01",
    featured: false,
  },
  {
    id: 5,
    slug: "shen-ji-zhao-huan-shi",
    title: "神级召唤师",
    altTitle: "Godly Summoner",
    author: "Lee Dong-wook",
    artist: "Choi Young",
    status: "连载中",
    category: "奇幻冒险",
    tags: ["奇幻", "游戏", "召唤", "升级"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20style%2C%20young%20man%20with%20magical%20summoning%20circle%20glowing%20golden%2C%20mythical%20creatures%20silhouettes%20behind%2C%20game%20interface%20elements%2C%20epic%20fantasy%20setting%2C%20dynamic%20composition%2C%20vibrant%20magic%20effects&width=800&height=1120&seq=comic-godly-summoner&orientation=portrait",
    description: "全球首款全息虚拟现实游戏《神域》上线，落魄大学生林风意外获得了隐藏职业——神级召唤师。从最底层开始，他凭借独特的召唤能力，一步步走向游戏的巅峰王座。",
    rating: 9.4,
    views: 1670000,
    chapters: 210,
    updateDate: "2026-07-02",
    featured: false,
  },
  {
    id: 6,
    slug: "jue-se-jiao-huan",
    title: "角色交换",
    altTitle: "Role Swap",
    author: "Jung Soo-young",
    artist: "Han Ji-eun",
    status: "已完结",
    category: "恋爱浪漫",
    tags: ["恋爱", "喜剧", "灵魂互换", "校园"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20webtoon%20style%2C%20boy%20and%20girl%20facing%20each%20other%20with%20surprised%20expressions%2C%20magical%20swirl%20between%20them%2C%20school%20uniforms%2C%20cherry%20blossom%20background%2C%20bright%20pastel%20colors%2C%20playful%20mood&width=800&height=1120&seq=comic-role-swap&orientation=portrait",
    description: "校园里水火不容的学霸和校霸，在一次意外中灵魂互换。被迫体验对方生活的两人，在啼笑皆非的日常中逐渐了解彼此，一段奇妙的恋爱故事就此展开。",
    rating: 9.2,
    views: 980000,
    chapters: 120,
    updateDate: "2026-05-20",
    featured: false,
  },
  {
    id: 7,
    slug: "an-he-zhi-wang",
    title: "暗黑之王",
    altTitle: "King of Darkness",
    author: "Park Sung-woo",
    artist: "Kim Tae-hyung",
    status: "连载中",
    category: "悬疑惊悚",
    tags: ["悬疑", "犯罪", "反英雄", "心理"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20dark%20thriller%20webtoon%20style%2C%20mysterious%20man%20in%20long%20black%20coat%20standing%20in%20rainy%20city%20alley%2C%20red%20crimson%20eyes%2C%20neon%20signs%20reflecting%2C%20noir%20atmosphere%2C%20dramatic%20contrast%2C%20clean%20dark%20art%20style&width=800&height=1120&seq=comic-king-darkness&orientation=portrait",
    description: "白天是受人尊敬的检察官，夜晚却是惩罚罪恶的黑暗执法者。双重身份的他，在光明与黑暗之间游走。当一起连环杀人案将线索指向他自己时，一切都变得扑朔迷离。",
    rating: 9.7,
    views: 2100000,
    chapters: 178,
    updateDate: "2026-07-03",
    featured: true,
  },
  {
    id: 8,
    slug: "jian-sheng-qian-jin",
    title: "剑圣千金",
    altTitle: "Sword Saint Daughter",
    author: "Choi Min-seo",
    artist: "Jung Hye-jin",
    status: "连载中",
    category: "武侠格斗",
    tags: ["武侠", "女性主角", "成长", "战斗"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20webtoon%20style%2C%20beautiful%20female%20swordswoman%20with%20long%20flowing%20hair%20holding%20ancient%20sword%2C%20traditional%20hanbok%20style%20attire%2C%20cherry%20blossom%20petals%20dancing%2C%20elegant%20yet%20powerful%20stance%2C%20soft%20watercolor%20effects&width=800&height=1120&seq=comic-sword-saint&orientation=portrait",
    description: "剑圣之女柳如烟，从小被当作家族耻辱。觉醒前世剑圣记忆后，她以惊人的速度成长。在这个男尊女卑的武林中，她要用手中的剑，斩出一条属于自己的道路。",
    rating: 9.4,
    views: 1450000,
    chapters: 145,
    updateDate: "2026-07-01",
    featured: false,
  },
  {
    id: 9,
    slug: "tian-cai-yi-sheng",
    title: "天才医生",
    altTitle: "Genius Doctor",
    author: "Lee Joon-ki",
    artist: "Park Soo-jin",
    status: "连载中",
    category: "都市现实",
    tags: ["都市", "医疗", "重生", "逆袭"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20webtoon%20style%2C%20young%20doctor%20in%20white%20coat%20with%20stethoscope%2C%20confident%20expression%2C%20hospital%20background%20with%20soft%20lighting%2C%20clean%20modern%20art%20style%2C%20warm%20professional%20atmosphere&width=800&height=1120&seq=comic-genius-doctor&orientation=portrait",
    description: "顶尖外科医生因医疗事故含冤而死，醒来竟重生为医学院的差生。凭借前世无双的医术，他从最底层开始，一步步成为医学界的传奇。手术刀下，生死逆转。",
    rating: 9.5,
    views: 1780000,
    chapters: 200,
    updateDate: "2026-07-02",
    featured: false,
  },
  {
    id: 10,
    slug: "mo-fa-shao-nu",
    title: "魔法少女的退休生活",
    altTitle: "Magical Girl Retirement",
    author: "Song Ji-won",
    artist: "Lee Min-ah",
    status: "已完结",
    category: "奇幻冒险",
    tags: ["奇幻", "魔法", "喜剧", "日常"],
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20comedy%20webtoon%20style%2C%20cute%20young%20woman%20in%20casual%20clothes%20holding%20coffee%20with%20magical%20sparkles%20around%2C%20modern%20city%20cafe%20background%2C%20bright%20cheerful%20colors%2C%20whimsical%20mood&width=800&height=1120&seq=comic-magical-retire&orientation=portrait",
    description: "拯救了世界之后，魔法少女决定退休享受普通人的生活。然而找房子、找工作、缴社保……现实生活远比对抗魔王更加困难！一部轻松搞笑的治愈系韩漫。",
    rating: 9.1,
    views: 890000,
    chapters: 88,
    updateDate: "2026-04-30",
    featured: false,
  },
];

export const categories = [
  { slug: "qihuan-maoxian", name: "奇幻冒险", icon: "ri-rocket-line", count: 1250 },
  { slug: "lianai-langman", name: "恋爱浪漫", icon: "ri-heart-line", count: 980 },
  { slug: "wuxia-gedou", name: "武侠格斗", icon: "ri-sword-line", count: 760 },
  { slug: "xuanyi-jingsong", name: "悬疑惊悚", icon: "ri-ghost-line", count: 540 },
  { slug: "dushi-xianshi", name: "都市现实", icon: "ri-building-line", count: 430 },
  { slug: "xiju-gaoxiao", name: "喜剧搞笑", icon: "ri-emotion-laugh-line", count: 380 },
];

export const testimonials = [
  {
    id: 1,
    name: "漫迷小林",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20cute%20anime%20girl%20avatar%20portrait%2C%20simple%20clean%20background%2C%20soft%20pastel%20colors%2C%20illustration%20style&width=120&height=120&seq=avatar-user-1&orientation=squarish",
    rating: 5,
    content: "韩漫画网真的是我见过最好用的韩漫阅读平台！下拉式阅读体验太流畅了，而且完全无删减，画质清晰。每天追更已经成为我的日常习惯，强烈推荐给所有韩漫爱好者！",
    date: "2026-06-28",
  },
  {
    id: 2,
    name: "追更达人阿强",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20handsome%20anime%20boy%20avatar%20portrait%2C%20simple%20clean%20background%2C%20cool%20expression%2C%20illustration%20style&width=120&height=120&seq=avatar-user-2&orientation=squarish",
    rating: 5,
    content: "更新速度超快，基本上韩网一出新章节这边就能看到。而且分类很齐全，从热门大作到冷门佳作都能找到。界面设计也很简洁舒适，长时间阅读眼睛也不会累。",
    date: "2026-06-25",
  },
  {
    id: 3,
    name: "深夜漫画党",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20cute%20anime%20character%20avatar%20portrait%20with%20glasses%2C%20simple%20background%2C%20warm%20colors%2C%20illustration%20style&width=120&height=120&seq=avatar-user-3&orientation=squarish",
    rating: 5,
    content: "作为一个看了五年韩漫的老读者，韩漫画网的阅读体验绝对是一流的。下拉式阅读不用翻页，沉浸感特别强。收藏功能也很方便，追漫再也不怕漏掉了。",
    date: "2026-06-20",
  },
  {
    id: 4,
    name: "漫评人小雨",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20pretty%20anime%20girl%20avatar%20portrait%20with%20long%20hair%2C%20simple%20clean%20background%2C%20elegant%20style%2C%20illustration&width=120&height=120&seq=avatar-user-4&orientation=squarish",
    rating: 4,
    content: "韩漫资源非常丰富，热门冷门都有覆盖。最喜欢的是无删减版本，能看到完整的剧情和画面。推荐指数五颗星！希望以后能增加更多完结作品的合集。",
    date: "2026-06-18",
  },
  {
    id: 5,
    name: "每日一漫",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20cool%20anime%20boy%20avatar%20portrait%20with%20hoodie%2C%20simple%20background%2C%20dark%20tone%2C%20illustration%20style&width=120&height=120&seq=avatar-user-5&orientation=squarish",
    rating: 5,
    content: "从朋友推荐过来用的，一用就停不下来。下拉式阅读这个设计真的太贴心了，不用频繁点击翻页。而且页面加载很快，基本上秒开。已经安利给身边所有看漫画的朋友了！",
    date: "2026-06-15",
  },
  {
    id: 6,
    name: "韩流追漫人",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20style%20cute%20anime%20character%20avatar%20portrait%20smiling%2C%20simple%20background%2C%20bright%20colors%2C%20illustration%20style&width=120&height=120&seq=avatar-user-6&orientation=squarish",
    rating: 4,
    content: "用了大半年了，整体体验很棒。更新及时，翻译质量也不错。最赞的是支持手机端阅读，通勤路上也能看。唯一的小建议是希望能增加夜间模式，晚上看会更舒服。",
    date: "2026-06-10",
  },
];

export const faqs = [
  {
    question: "韩漫画网是否需要付费？",
    answer: "韩漫画网完全免费！我们致力于为所有韩漫爱好者提供免费的优质阅读体验。您无需支付任何费用即可畅读全站所有漫画内容，包括热门连载和经典完结作品。",
  },
  {
    question: "什么是下拉式阅读？如何使用？",
    answer: "下拉式阅读是一种创新的连续阅读方式。您只需在漫画详情页面向下滑动，所有漫画章节会自动连续加载，无需点击翻页按钮。这种沉浸式设计让您可以像刷社交媒体一样轻松阅读漫画，获得更加流畅的阅读体验。",
  },
  {
    question: "韩漫画网的漫画是否无删减？",
    answer: "是的，韩漫画网所有漫画均为无删减完整版。我们坚持提供原汁原味的韩漫内容，不进行任何形式的删减或修改，确保您能看到创作者原本想要呈现的完整故事和画面。",
  },
  {
    question: "漫画更新频率如何？",
    answer: "我们与韩网保持同步更新，热门连载漫画通常在韩网更新后24小时内完成翻译并上线。您可以在首页的「最新更新」区域查看最近更新的漫画列表，也可以在漫画详情页查看具体更新日期。",
  },
  {
    question: "是否支持手机端阅读？",
    answer: "完全支持！韩漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。特别是手机端的下拉式阅读，只需单指滑动即可连续阅读，操作简单便捷，给您最佳的移动阅读体验。",
  },
  {
    question: "如何搜索想看的漫画？",
    answer: "您可以通过首页顶部的搜索框输入漫画名称进行搜索，也可以通过分类页面按类型浏览。我们还提供了热门标签筛选功能，帮助您更快找到感兴趣的作品。",
  },
];